import { REPORTING_ENABLED } from './is-production-host';


// logrocket 0.6 downloads its recorder (cdn.logrocket.io/logger.min.js) as soon as the
// package is imported; LogRocket.init only starts recording. With window._disableLogRocket
// set, the import returns a no-op instance instead. Imported by utils/logrocket before
// 'logrocket', so it runs first; only a reporting build keeps the real one.
if ( ! REPORTING_ENABLED) {
  window._disableLogRocket = true;
}
